import React from "react";
import OrgProfContainer from "../../modules/OrgProf/containers/OrgProfContainer/OrgProfContainer";

const OrgProf = () => {
  return (
    <OrgProfContainer />
  );
};

export default OrgProf;
